import { render, staticRenderFns } from "./ProjectInformation.vue?vue&type=template&id=bf50e700&scoped=true"
import script from "./ProjectInformation.vue?vue&type=script&lang=ts"
export * from "./ProjectInformation.vue?vue&type=script&lang=ts"
import style0 from "./ProjectInformation.vue?vue&type=style&index=0&id=bf50e700&prod&lang=scss&scoped=true"
import style1 from "./ProjectInformation.vue?vue&type=style&index=1&id=bf50e700&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf50e700",
  null
  
)

export default component.exports